import { GLOBAL_STATE_TYPES } from '@smarty-nx/data'

export const PLAN_STATES = {
  ACTIVE: GLOBAL_STATE_TYPES.ACTIVE,
  EXPIRED: GLOBAL_STATE_TYPES.EXPIRED,
  PAYMENT_REQUIRED: GLOBAL_STATE_TYPES.PAYMENT_REQUIRED,
  PAUSED: GLOBAL_STATE_TYPES.PAUSED,
  SUSPENDED: GLOBAL_STATE_TYPES.SUSPENDED,
}

export const NON_ACTIVATED_STATES = [
  GLOBAL_STATE_TYPES.AWAITING_ORDER,
  GLOBAL_STATE_TYPES.AWAITING_NUMBER,
  GLOBAL_STATE_TYPES.PENDING,
]

export const PLAN_CHANGE_STATES = {
  PENDING: GLOBAL_STATE_TYPES.PENDING,
  SUCCESS: GLOBAL_STATE_TYPES.SUCCESS,
  FAILURE: GLOBAL_STATE_TYPES.FAILURE,
}

export enum IS_GROUP_MEMBER_VALUES {
  YES_OWNER = 'yes-owner',
  YES = 'yes',
  NO = 'no',
}
